export const APP_VERSION = __APP_VERSION__
